import { DateTime } from 'luxon'

export const isToday = (date: DateTime) => {
  const diff = date.diffNow('days').days

  return diff > -1 && diff < 0
}
